import { useEffect } from "react"
import useSWR from "swr"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { SPIDERTRACKS_POLL_MS } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectSpidertracksEnabled } from "features/overview/slice"
import { setSpidertracksLivePositions } from "./aircraftLivePositionStore"

export const useSpidertracksTracking = (orgId: string | undefined) => {
    const enabled = useAppSelector(selectSpidertracksEnabled)

    const swr = useSWR(
        orgId && enabled ? ["spidertracks", orgId] : null,
        () => fetchApiGateway("get /org/:orgId/spidertracks", { params: { orgId: orgId! } }),
        {
            refreshInterval: SPIDERTRACKS_POLL_MS,
            revalidateOnFocus: false,
            shouldRetryOnError: false,
        }
    )

    useEffect(() => setSpidertracksLivePositions(swr.data?.aircraft ?? []), [swr.data])

    return swr
}
